import React, {type FC} from 'react';
import {Alignment} from '../../../constants';
import {useGlobals} from '../../../providers/globalPropsProvider';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import {ProductMediaDots} from '../ProductGalleryLayout/ProductMediaDots/ProductMediaDots';
import {ProductMediaSwiper} from '../ProductGalleryLayout/ProductMediaSwiper/ProductMediaSwiper';
import s from './ProductGalleryNavigation.scss';

export enum ProductGalleryNavigationDataHook {
  Root = 'product-gallery-navigation-root',
}

export interface ProductGalleryNavigationProps {
  align: Alignment;
}

export const ProductGalleryNavigation: FC<ProductGalleryNavigationProps> = ({align}) => {
  const {
    product: {media},
  } = useGlobals();

  const getNativeThumbnailRatio = () => {
    /* istanbul ignore next: defensive, hard to test */
    if (!media[0]?.width || !media[0]?.height) {
      return 1;
    }

    return media[0].width / media[0].height;
  };

  return (
    <div
      className={s.navigationContainer}
      data-hook={ProductGalleryNavigationDataHook.Root}
      style={{'--nativeThumbnailRatio': getNativeThumbnailRatio()} as React.CSSProperties}>
      <ConditionalRender by="shouldRenderDotsNavigation" className={s.navigation}>
        <ProductMediaDots media={media} />
      </ConditionalRender>
      <ConditionalRender by="shouldRenderHorizontalThumbnails" className={s.navigation}>
        <ProductMediaSwiper media={media} isVertical={false} align={align} />
      </ConditionalRender>
      <ConditionalRender by="shouldRenderVerticalThumbnails" className={s.navigation}>
        <ProductMediaSwiper media={media} isVertical={true} align={align} />
      </ConditionalRender>
    </div>
  );
};
